import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import Logo from "../../assets/Logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Warna teks berdasarkan scroll
  const linkClass = isScrolled
    ? "text-white hover:text-pink-300 transition-all duration-300"
    : "text-white hover:text-pink-200 transition-all duration-300";

  // Warna navbar background berdasarkan scroll
  const navClass = `w-full fixed top-0 left-0 z-50 p-4 px-6 flex justify-between items-center transition-all duration-500 ${
    isScrolled
      ? "bg-pink-800 shadow-md"
      : "bg-white/1 "
  }`;

  return (
    <nav className={navClass}>
      {/* Logo */}
      <RouterLink to="/" className="flex items-center gap-2">
        <img src={Logo} alt="Logo" className="w-14 h-14" />
      </RouterLink>

      {/* Desktop Menu */}
      <ul className="hidden md:flex gap-6 text-sm font-semibold">
        <li><RouterLink to="/" className={linkClass}>HOME</RouterLink></li>
        <li><RouterLink to="/menu" className={linkClass}>MENU</RouterLink></li>
        <li><ScrollLink to="promo" smooth={true} duration={500} offset={-80} className={`cursor-pointer ${linkClass}`}>PROMO</ScrollLink></li>
        <li><RouterLink to="/#location" className={linkClass}>LOCATION</RouterLink></li>
        <li><ScrollLink to="contact" smooth={true} duration={500} offset={-80} className={`cursor-pointer ${linkClass}`}>CONTACT US</ScrollLink></li>
        <li><RouterLink to="/About" className={linkClass}>ABOUT</RouterLink></li>
      </ul>

      {/* Mobile Menu Toggle */}
      <div className="md:hidden pr-3 text-white">
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Content */}
      {isOpen && (
        <div className={`absolute top-16 left-0 w-full p-4 md:hidden transition-all duration-500 ${isScrolled ? "bg-pink-800" : "bg-white/10 backdrop-blur-md "}`}>
          <ul className="flex flex-col gap-4 text-center">
            <li><RouterLink to="/" onClick={() => setIsOpen(false)} className={linkClass}>HOME</RouterLink></li>
            <li><RouterLink to="/Menu" onClick={() => setIsOpen(false)} className={linkClass}>MENU</RouterLink></li>
            <li><ScrollLink to="promo" smooth={true} duration={500} offset={-80} onClick={() => setIsOpen(false)} className={`cursor-pointer ${linkClass}`}>PROMO</ScrollLink></li>
            <li><RouterLink to="/#location" onClick={() => setIsOpen(false)} className={linkClass}>LOCATION</RouterLink></li>
            <li><ScrollLink to="contact" smooth={true} duration={500} offset={-80} onClick={() => setIsOpen(false)} className={`cursor-pointer ${linkClass}`}>CONTACT US</ScrollLink></li>
            <li><RouterLink to="/About" onClick={() => setIsOpen(false)} className={linkClass}>ABOUT</RouterLink></li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
